import { styled } from '@mui/material';

export const CodeBlockSelect = styled('select')(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.text.secondary,
  border: 'none',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0, 1.2, 0, 1),
  paddingRight: theme.spacing(1.2),
  fontSize: '0.875rem',
  lineHeight: 1.75,
  '&:focus': {
    outline: 'none',
    borderColor: theme.palette.primary.main,
  },
  '&:hover': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
  },
}));
